package fyi.moko.hotpl.data.service

import fyi.moko.hotpl.domain.service.UsageTrackingPreference
import kotlinx.browser.localStorage
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

/** `localStorage`-backed [UsageTrackingPreference]; defensive like [JsHomeViewPreference]. On until switched off. */
class JsUsageTrackingPreference : UsageTrackingPreference {
    private val _enabled = MutableStateFlow(load())
    override val enabled = _enabled.asStateFlow()

    override suspend fun setEnabled(value: Boolean) {
        _enabled.value = value
        try {
            localStorage.setItem(KEY, value.toString())
        } catch (e: Throwable) {
            console.error("Failed to persist the usage tracking preference to localStorage", e)
        }
    }

    private fun load(): Boolean = try {
        localStorage.getItem(KEY) != "false"
    } catch (e: Throwable) {
        console.error("Failed to read the usage tracking preference from localStorage", e)
        true
    }

    private companion object {
        const val KEY = "hotpl_usage_tracking_enabled"
    }
}
